module.exports = __webpack_public_path__ + "img/hair_front_male_short.3a0b2fe6.png";